import { buildUserAndPendingMessages } from './buildUserAndPendingMessages'
import { priorMessagesWithoutPending } from './priorMessagesWithoutPending'

export function prepareSendTurn({ tid, messages, trimmed, files }) {
  const priorMessages = priorMessagesWithoutPending({ [tid]: messages }, tid)
  const now = Date.now()
  const { userMsg, pendingId, pendingAssistant } = buildUserAndPendingMessages({
    trimmed,
    files,
    versionIndex: 0,
    now,
    includeAgentMeta: true,
  })
  const apiMessages = [...priorMessages, userMsg].map((msg) => ({
    role: msg.role,
    content: msg.text,
  }))
  return { userMsg, pendingId, pendingAssistant, priorMessages, apiMessages }
}
